import { Divider, Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import { useVirtualMachineModules } from "@/organisms/Drawers/applications/inventory/useInventory"
import { Form } from "@/organisms/Form"
import { VerticalTabTemplate } from "@/pages/SettingsPage/components/templates/VerticalTabTemplate/VerticalTabTemplate"
import { Configuration } from "./components/Configuration"

import styles from "./ConfigurationTabVirtualMachineDrawer.module.scss"

import { ReadInstructionButton } from "@/molecules/ReadInstructionButton"
import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

export const ConfigurationTabVirtualMachineDrawer = (
  props: TabComponentProps
) => {
  const { record } = props
  const modulesCtx = useVirtualMachineModules(record?.id)
  const { t } = useTranslation("translation", {
    keyPrefix: "inventory.vm.drawer.configuration"
  })

  return (
    <VerticalTabTemplate
      placement="drawer"
      title={
        <Flex vertical flex={1} className={styles.headerSection}>
          <Heading level={5} title={t("subtitle")} />
          <Text type="secondary" className="sm-text-ks">
            {t("description")}
          </Text>
        </Flex>
      }
      button={
        <Flex vertical flex={1} align="end" className={styles.headerSection}>
          <ReadInstructionButton needle="/kodem-basics/vm-to-code-repository-correlation" />
        </Flex>
      }
    >
      <Flex vertical className={styles.wrapper}>
        <Divider className="divider-m-0" />
        <Form.Page
          id="configuration-tab-vm-drawer"
          Component={Configuration}
          loading={modulesCtx.isLoading}
          {...props}
        />
      </Flex>
    </VerticalTabTemplate>
  )
}
